module.exports = __webpack_public_path__ + "img/podomatic.57198147.svg";